import { createFileRoute } from "@tanstack/react-router";
import { ProductPage } from "@/components/site/ProductPage";
import { ConstructionCalculator } from "@/components/site/ConstructionCalculator";
import { ConstructionExtras } from "@/components/site/ConstructionExtras";
import { getProduct } from "@/data/products";
import { getProductHero } from "@/data/productHeroes";
import { buildHead } from "@/lib/seo-head";

const SLUG = "construction-loans";
const PRODUCT = getProduct(SLUG)!;
const HERO = getProductHero(SLUG);
const URL = `/${SLUG}`;

const KEYWORDS = [
  "construction loan",
  "ground up construction loan",
  "investment property construction loan",
  "construction to DSCR loan",
  "spec home construction financing",
  "builder construction draw loan",
  "new construction rental loan",
  "construction loan for investors",
  "construction loan LLC",
  "construction loan rates",
  "12 month construction loan",
  "construction takeout loan",
].join(", ");

export const Route = createFileRoute("/construction-loans/")({
  head: () =>
    buildHead({
      title: "Ground-Up Construction Loans for Investors",
      description:
        "12–24 month ground-up construction financing for investment builds with an efficient DSCR takeout on completion. Draws every 2 weeks.",
      url: URL,
      keywords: KEYWORDS,
      image: HERO?.src,
      imageAlt: HERO?.alt,
      breadcrumbs: [
        { name: "Home", url: "/" },
        { name: PRODUCT.shortName, url: URL },
      ],
      service: { name: PRODUCT.name },
      faqs: PRODUCT.faq.map((f) => ({ q: f.q, a: f.a })),
    }),

  component: () => (
    <ProductPage
      product={PRODUCT}
      hideBaseTools
      extraTools={
        <>
          <ConstructionCalculator />
          <ConstructionExtras />
        </>
      }
    />
  ),
});
